import { render, staticRenderFns } from "./ApiErrorsByDateBarChart.vue?vue&type=template&id=0bd4520d&scoped=true&"
import script from "./ApiErrorsByDateBarChart.vue?vue&type=script&lang=js&"
export * from "./ApiErrorsByDateBarChart.vue?vue&type=script&lang=js&"
import style0 from "./ApiErrorsByDateBarChart.vue?vue&type=style&index=0&id=0bd4520d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd4520d",
  null
  
)

export default component.exports